<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'"
                                 type="select" label="运营模式" name="operation_mode" :options="operationMode"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="hidden" name="stationed_id"></c-form-item>
					<c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="input" label="订单号" name="order_number"></c-form-item>
					<c-form-item type="input" label="代理手机号" name="user_manage_mobilephone"></c-form-item>
					<c-form-item type="input" label="会员昵称" name="nick_name"></c-form-item>
					<c-form-item type="input" label="业务员姓名" name="salesman_realname"></c-form-item>
					<c-form-item type="input" label="商品名称" name="product_name" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="收货信息" name="receiving_info" placeholder="收货人、电话、地址"></c-form-item>
                    <c-form-item type="input" label="运单号" name="logistics_number" placeholder="模糊匹配"></c-form-item>
                    <c-form-item type="input" label="采购单号" name="purchase_order_number"></c-form-item>
                    <c-form-item type="datetime" label="下单时间" start-name="start_date" end-name="end_date"></c-form-item>
                    <c-form-item type="datetime" label="付款时间" start-name="pay_start_date" end-name="pay_end_date"></c-form-item>
                    <c-form-item type="checkbox" label="" name="order_type" :options="orderType"></c-form-item>
                    <c-form-item type="checkbox" label="" name="order_classify" :options="orderClassify"></c-form-item>
                    <c-form-item type="checkbox" v-if="systemConfig.order_check_enabled == 'ON' || systemConfig.cash_pay == 'ON'" label="" name="check_state" :options="checkState"></c-form-item>
					<c-form-item type="checkbox" label="" name="order_state" :options="orderState"></c-form-item>
					<c-form-item v-if="systemConfig.order_invoice_enabled == 'ON'" type="checkbox" label="" name="invoice_state" :options="invoiceState"></c-form-item>
					<c-form-item v-if="systemConfig.order_push_enabled == 'ON'" type="checkbox" label="推送状态:" name="push_state" :options="pushState"></c-form-item>
				</c-form>
			</m-search>
			<m-operate>
                <c-button power="b_order_deliver" @click="$refs.excelImport.open()" color="gray" hollow icon="excel">导入发货</c-button>
                <c-button power="b_order_export" @click="exportData()" icon="export">导出订单明细</c-button>
                <c-button power="b_order_invoice_finish" v-if="systemConfig.order_invoice_enabled == 'ON'" @click="batchInvoiceFinish()">批量开票完成</c-button>
                <c-button color="m" hollow @click="syncExport()">(同步)导出订单明细</c-button>

                <template #right>
                    <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                </template>
            </m-operate>
			<c-table ref="table">
				<c-table-column type="selector"></c-table-column>
				
				<c-table-column
					label="订单号"
					name="order_number"
					width="120"
				>
					<template v-slot="{data}">
						<a class="s-link" style="text-decoration: underline;" @click="navigateTo(`/order_detail/${data.order_number}`)">{{data.order_number}}</a>
					</template>
				</c-table-column>
				
				<c-table-column
					label="运营模式"
					name="operation_mode"
					width="80"
					v-if="systemConfig.pt_mode == 2 && systemConfig.operation_mode_enabled == 'ON'" 
				>
					<template v-slot="{data}">
						{{operationModeName[data.operation_mode]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="商家角色"
					name="stationed_auth_name"
					width="125"
					v-if="systemConfig.pt_mode == 2 && systemConfig.stationed_authname_enabled == 'ON'" 
				>
				</c-table-column>
				
				<c-table-column
					label="商家名称"
					name="stationed_name"
					width="150"
					v-if="systemConfig.pt_mode == 2" 
				></c-table-column>
				
				
				<c-table-column
					label="订单/商品类型"
					name="order_type"
					width="120"
				>
					<template v-slot="{data}">
            {{orderTypeName[data.order_type]}}/{{orderClassifyName[data.order_classify]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="订单来源"
					name="order_source"
					width="80"
				>
					<template v-slot="{data}">
						{{orderSourceName[data.order_source]}}
					</template>
				</c-table-column>
				
				<c-table-column
					label="审核状态"
					name="check_state"
					width="80"
					v-if="systemConfig.order_check_enabled == 'ON' || systemConfig.cash_pay == 'ON'"
				>
					<template v-slot="{data}">
						<template v-if="data.payment_state == 1">
							<span v-if="data.payment_type=='转账支付'" style="color:#182eff">待审核</span>
							<span v-else style="color:#bbbbbb">--</span>
						</template>
						<template v-else>
							<span v-if="data.check_state==1 && data.order_state != 6" style="color:#182eff">待审核</span>
							<span v-if="data.check_state==1 && data.order_state == 6" style="color:#bbbbbb">--</span>
							<span v-if="data.check_state==2 && data.push_state == 1" style="color:#e1b504">审核通过</span>
							<span v-if="data.check_state==2 && (data.push_state == 0 || data.push_state == 2)" style="color:darkgreen">审核通过</span>
							<span v-if="data.check_state==3" style="color:#ff5555">不通过</span>
						</template>
					</template>
				</c-table-column>
				
				<c-table-column
					label="订单状态"
					name="order_state"
					width="140"
				>
					<template v-slot="{data}">
						<span v-if="data.order_state == 6" style="color:#999">
                            {{orderStateName[data.order_state]}}
                            <span v-if="data.cancel_reason_type_id<=0 && data.cancel_reason_type_name">({{data.cancel_reason_type_name}})</span>
                        </span>
						<span v-else-if="data.check_state==1" style="color:#182eff">
                            <span v-if="data.order_state==1 && data.payment_type == '转账支付'&& data.payment_date">
                                转账支付支付(待审)
                            </span>
                            <span v-else>{{orderStateName[data.order_state]}}</span>
                        </span>
						<span v-else-if="data.check_state==3" style="color:#182eff">{{orderStateName[data.order_state]}}</span>
						<span v-else-if="data.check_state==2">
							<span v-if="data.refund_flag == 1" style="color: #ff5555">退款中({{data.refund_count}})</span>
							<span v-else-if="data.return_flag == 1" style="color: #ff5555">退货中({{data.return_count}})</span>
							<span v-else>
								<span v-if="data.payment_state == 2" style="color:#708fff">待付尾款</span>
								<span v-else>
									<span v-if="data.order_state == 1" style="color:#888888">{{orderStateName[data.order_state]}}</span>
									<span v-if="data.order_state == 2">
                                        <span v-if="data.order_type == 8 && data.group_achieve == 0"  style="color:gray">
                                           待成团
                                        </span>
                                        <span v-else  style="color:#182eff">
                                             {{orderStateName[data.order_state]}}
                                        </span>
                                    </span>
									<span v-if="data.order_state == 3" style="color:#69d39c">{{orderStateName[data.order_state]}}</span>
									<span v-if="data.order_state == 5" style="color:darkgreen">{{orderStateName[data.order_state]}}</span>
								</span>
							</span>
							<span v-if="data.order_state==3 && data.deliver_state=='部分发货'"><br/> (<span style="color:dodgerblue">{{ data.deliver_state}}</span>)</span>
						</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="开票状态"
					name="invoice_state"
					width="110"
					v-if="systemConfig.order_invoice_enabled == 'ON'" 
				>
					<template v-slot="{data}">
						<span v-if="data.order_state == 3 || data.order_state == 5">
							<span style="color:#bbbbbb" v-if="data.invoice_count > 0 && data.invoice_state==1 && data.exp_date_count < 10">{{invoiceStateName[data.invoice_state]}}(10天内)</span>
							<span style="color:#00aaff" v-if="data.invoice_count > 0 && data.invoice_state==1 && data.exp_date_count >= 10 && data.exp_date_count < 20">{{invoiceStateName[data.invoice_state]}}(超10天)</span>
							<span style="color:#e1e100" v-if="data.invoice_count > 0 && data.invoice_state==1 && data.exp_date_count >= 20 && data.exp_date_count < 30">{{invoiceStateName[data.invoice_state]}}(超20天)</span>
							<span style="color:red" v-if="data.invoice_count > 0 && data.invoice_state==1 && data.exp_date_count >= 30">{{invoiceStateName[data.invoice_state]}}(超30天)</span>
							<span style="color:#79f3b4" v-if="data.invoice_count == 0 && data.invoice_state==1">{{invoiceStateName[0]}}</span>
							<span style="color:darkgreen" v-if="data.invoice_state==2">{{invoiceStateName[data.invoice_state]}}</span>
						</span>
						<span v-else style="color:#dddddd" >--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="推送状态"
					name="push_state"
					width="80"
					v-if="systemConfig.order_push_enabled == 'ON'"
				>
					<template v-slot="{data}">
						<span v-if="data.push_state==0"><span style="color:#bbbbbb">无需推送</span></span>
						<span v-if="data.push_state==1 && data.order_state != 6"><span style="color:#182eff">待推送</span></span>
						<span v-if="data.push_state==1 && data.order_state == 6"><span style="color:#bbbbbb">--</span></span>
						<span v-if="data.push_state==2"><span style="color:darkgreen">已推送</span></span>
					</template>
				</c-table-column>

                <c-table-column
                        label="代理手机号"
                        name="user_manage_mobilephone"
                        width="120"
                ></c-table-column>

                <c-table-column
                        label="代理头像/昵称"
                        name="head_photo"
                        width="120"
                >
                    <template v-slot="{data}">
                        <div class="flex-center-cross">
                            <c-image :src="data.head_photo" preview size="30" style="margin-right: 10px;"></c-image>
                            <span>{{data.nick_name||'--'}}</span>
                        </div>
                    </template>
                </c-table-column>

                <c-table-column
                        label="会员名"
                        name="user_login_name"
                        width="140"
                ></c-table-column>
				
				<c-table-column
					label="业务员"
					name="salesman_realname"
					width="120"
				>
					<template v-slot="{data}">
						<span v-if="data.salesman_realname">
							{{data.salesman_realname}}
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="下单时间"
					name="create_date"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="购买数量"
					name="product_count"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="订单金额"
					name="product_money"
					width="180"
				>
				<template v-slot="{data}">
					<span v-if="data.order_type==2" style="color:#888888">
						{{data.product_money}}（积分）
					</span>
					<span v-if="data.order_type==2 && data.logistics_money > 0" style="color:orangered">
						(另运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
					</span>
					<span v-if="data.order_type!=2 && data.payment_state != 3" style="color:#888888">
						￥{{parseFloat(data.product_money+data.custom_money+data.logistics_money + data.total_fee_money).toFixed(2)}}
					</span>
					<span v-if="data.order_type!=2 && data.payment_state == 3" style="color:darkgreen">
						￥{{parseFloat(data.payment_money).toFixed(2)}}
					</span>
					<span v-if="data.order_type!=2 && data.logistics_money > 0" style="color:orangered">
						(含运费￥{{parseFloat(data.logistics_money).toFixed(2)}})
					</span>
					<span v-if="data.order_type!=2 && data.total_fee_money > 0" style="color:orangered">
						<br/>(含服务费￥{{parseFloat(data.total_fee_money).toFixed(2)}})
					</span>
					<span v-if="data.order_type==7 && data.custom_money > 0" style="color:orangered">
						<br/>(含定制费￥{{parseFloat(data.custom_money).toFixed(2)}})
					</span>
				</template>
				</c-table-column>
				
				<c-table-column
					label="付款金额"
					name="payment_money"
					width="90"
				>
					<template v-slot="{data}">
						<span v-if="data.payment_money" style="color:darkgreen">
							￥{{parseFloat(data.payment_money).toFixed(2)}}
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="付款时间"
					name="payment_date"
					width="150"
				>
					<template v-slot="{data}">
						<span v-if="data.payment_date">
							{{data.payment_date}}
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column>
				
				<c-table-column
					label="收货人"
					name="receiving_name"
					width="110"
				></c-table-column>
				
				<c-table-column
					label="收货人电话"
					name="receiving_phone"
					width="120"
				></c-table-column>
				
				<c-table-column
					label="配送方式"
					name="logistics_company_name"
					width="90"
				></c-table-column>
				
				<!-- <c-table-column
					label="是否到付"
					name="freight_payment_type"
					width="80"
				>
					<template v-slot="{data}">
						{{freightPaymentTypeName[data.freight_payment_type]}}
					</template>
				</c-table-column> -->
				
				<!-- <c-table-column
					label="备注"
					name="order_remark"
					width="110"
				>
					<template v-slot="{data}">
						<span v-if="data.order_remark">
							{{data.order_remark}}
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column> -->
				
				<c-table-column
					label="发货时间"
					name="send_dates"
					width="160"
				>
					<template v-slot="{data}">
						<span v-if="data.send_dates">
                            <p v-for="(item, i) in data.send_dates.split(',')" style="margin-right: 10px;">{{item}}</p>
						</span>
						<span v-else style="color:#bbbbbb" >--</span>
					</template>
				</c-table-column>

                <c-table-column
                        label="采购单号"
                        name="purchase_order_number"
                        width="130"
                >
                    <template v-slot="{data}">
						<span v-if="data.purchase_order_number">
                            <a class="s-link" style="text-decoration: underline;" @click="navigateTo(`/purchase_order_detail/${data.purchase_order_number}`)">{{data.order_number}}</a>
						</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="230"
				>
					<template v-slot="{data}">
						<c-table-button v-if="data.operation_mode != 2 && data.check_state==1 && data.order_state != 6" @click="navigateTo(`/order_detail/${data.order_number}`)">审批</c-table-button>
						<c-table-button v-else @click="navigateTo(`/order_detail/${data.order_number}`)">查看</c-table-button>
                        <c-button power="b_order_transfer_purchaseh" v-if="data.payment_state && data.transfer_purchase_state==1 && !data.purchase_order_number && data.order_state!=6"  @click="transferPurchaseh(data)" size="m" hollow>转采购单</c-button >
                        <c-button v-if="data.order_state <= 2" power="b_order_update_remark"  @click="reMarkHandle(data)" size="m" hollow>修改买家留言</c-button >
                        <c-table-button v-if="(data.order_type == 1 || data.order_type == 5 || data.order_type == 6) && data.check_state == 2 && data.refund_flag!=1 && data.return_flag!=1 && (data.order_state==2 || data.order_state==3 || data.order_state==5)" power="b_order_refund_apply" @click="navigateTo(`/after_sales_apply?orderNumber=${data.order_number}`)">申请售后</c-table-button>
						<c-table-button v-if="data.refund_flag != 1 && data.return_flag!=1 && (data.order_state == 1 || data.order_state == 2)" power="b_order_close" @click="closeHandle(false,data)">关闭</c-table-button>
						<c-table-button v-if="data.operation_mode != 2 && data.check_state == 2 && data.refund_flag!=1 && data.return_flag!=1 && data.invoice_state == 1 && data.invoice_count > 0 && (data.order_state == 3 || data.order_state == 5)" power="b_order_invoice_finish" @click="onInvoiceFinish(data)">开票完成</c-table-button>
						<c-table-button v-if="systemConfig.order_invoice_enabled == 'ON' && data.operation_mode != 2 && data.refund_flag != 1 && data.return_flag!=1 && (data.order_state == 1 || data.order_state == 2)" power="b_order_edit_receiving_address" @click="editReceivingAddress(data)">修改收货信息</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		<!-- 关闭订单弹框 -->
		<c-dialog ref="closeDia" title="取消订单" width="600" @resolve="closeHandle">
			<div class="order-verify">
			  	<textarea v-model="cancel_reason" placeholder="请输入取消原因..."></textarea>
			</div>
		</c-dialog>
		<!--修改收货地址弹框 -->
		<c-dialog ref="receivingDia" title="修改收货地址" width="700" @resolve="receivingSubmitForm">
		    <c-form ref="receivingForm">
		        <c-form-item type="hidden" name="order_number"></c-form-item>
		        <c-form-item type="input" label="收货人" name="receiving_name" required></c-form-item>
		        <c-form-item type="input" label="电话" name="receiving_phone" required></c-form-item>
		        <c-form-item type="input" label="收货地址" name="receiving_address" required></c-form-item>
		    </c-form>
		</c-dialog>
		<!--开票完成弹框 -->
		<c-dialog ref="invoiceConf" title="开票确认" button-name="确认开票完成" width="550" height="360" @resolve="submitInvoiceFinish">
			<c-form ref="invoiceConfForm">
			<div class="invoice">
				<p v-html="text_msg"></p>
				<c-form-item type="datetime" v-model="invoiceDate" label="开票时间" ></c-form-item>
				<c-form-item type="number" v-if="is_bath == 0" v-model="realityMoney" :limit="9999999" decimal="2" label="实收金额" ></c-form-item>
				<p v-if="is_bath == 1" style="color:red">批量开票时,默认实收金额与订单支付金额一致</p>
                <c-form-item type="radio" v-if="is_bath == 0" label="开票凭证" name="invoice_file_type" v-model="invoice_file_type" :options="invoiceFileType"></c-form-item>
                <c-form-item type="file" v-if="is_bath == 0 && invoice_file_type == 1" label="附件" v-model="invoice_file" name="invoice_file" file-type="image,pdf"></c-form-item>
                <c-form-item type="input" v-if="is_bath == 0 && invoice_file_type == 2" label="链接" v-model="invoice_file" word="http://或https://开头" name="invoice_file" ></c-form-item>
			</div>
			</c-form>
		</c-dialog>
        <!--客服备注弹框（输入） -->
        <c-dialog ref="orderRemark" title="修改买家留言" width="600" @resolve="orderRemarkHandle">
            <div class="order-remark">
                <textarea v-model="orderRemark" maxlength="150" placeholder="请输入买家留言内容..."></textarea>
            </div>
        </c-dialog>
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
		<order-transfer-purchase ref="orderTransferPurchase"></order-transfer-purchase>
        <excel-import ref="excelImport" :work-type="importWorkType" @resolve="$refs.table.update();"></excel-import>
    </page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'         // 商家库
	import orderTransferPurchase from '@/components/service/order_transfer_purchase.vue'    // 转采购单
    import excelImport from "@/components/service/import_excel_data.vue";  // 导入数据
    import {mapState} from 'vuex'
	export default {
		name: 'm_order_sell',

		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector,
            orderTransferPurchase,
            excelImport
		},

        props: {
            check_state: String,
            order_state: String,
            invoice_state: String,
            pay_state: String,
            reconciliation_state: String
        },

        data() {
			return {
                importWorkType:901,//导入发货业务代码
                workType:14,
                searchParams:{},
                is_bath:0,
                text_msg:'',
                realityMoney: 0,
				invoiceDate:'',	//开票时间
				cancel_reason:'', //关闭原因
                invoice_file_type:'',//开票文件类型
                invoice_file:'',//发票文件
				orderStateName: {
					1: '待付款',
					2: '待发货',
					3: '待收货',
					5: '交易完结',
					6: '已关闭'
				},
				operationModeName: {
					1: '平台自营',
					2: '商家自营'
				},
				orderTypeName: {
					1: '普通',
					2: '积分',
					3: '赠品',
					4: '砍价',
					5: '预售订单(全款)',
					6: '预售订单(定金)',
					7: '定制',
					8: '拼团',
					9: '云仓提货'
				},
				orderSourceName: {
					'OMS':'管理后台',
					'IOS': '苹果',
					'ANDROID': '安卓',
					'MINI': '小程序',
					'PC': 'PC电脑'
				},
				freightPaymentTypeName:{
					1: '运费先付',
					2: '运费到付'
				},
				orderState: [{
						name: '待付款',
						value: 1
					},{
						name: '待发货',
						value: 2
					},{
						name: '待收货',
						value: 3
					},{
						name: '交易完结',
						value: 5
					},{
						name: '已关闭',
						value: 6
					}
				],
				checkState: [{
						name: '待审核',
						value: 1
					},{
						name: '审核通过',
						value: 2
					},{
						name: '审核不通过',
						value: 3
					}
				],
				invoiceStateName: {
					0: '无需开票',
					1: '未开票',
					2: '已开票'
				},
				pushState: [{
						name: '无需推送',
						value: 0
					},{
						name: '待推送',
						value: 1
					},{
						name: '已推送',
						value: 3
					}
				],
                operationMode: [
                    {name: '平台自营',value: 1},
                    {name: '商家自营',value: 2}
                ],
				invoiceState:[{
						name: '无需开票',
						value: 0
					},{
						name: '未开票',
						value: 1
					},{
						name: '已开票',
						value: 2
					}
				],
                invoiceFileType:[{
                    name: '附件',
                    value: 1
                },{
                    name: '链接',
                    value: 2
                }],
                orderNumber:'',
                orderRemark: '', //订单买家留言
                orderClassify:[
                    {name: '实物',value: 1},
                    {name: '虚拟',value: 2}
                ],
                orderClassifyName: {
                    1: '实物',
                    2: '虚拟'
                },
            }
		},

        computed: {
            ...mapState(['systemConfig', 'userInfo']),
			
			orderType() {
				return (
					[{
						name: '普通',
						value: 1
					},{
                        name: '赠品',
                        value: 3
                    }].concat(this.systemConfig.points_system == 'ON'?[{
						name: '积分',
						value: 2
					}]:[])
					.concat(this.systemConfig.bargain_enabled == 'ON'?[{
						name: '砍价',
						value: 4
					}]:[])
					.concat(this.systemConfig.presell_enabled == 'ON'?[{
						name: '预售订单(全款)',
						value: 5
					}]:[])
					.concat(this.systemConfig.presell_enabled == 'ON'?[{
						name: '预售订单(定金)',
						value: 6
					}]:[])
					.concat(this.systemConfig.product_custom == 'ON'?[{
						name: '定制',
						value: 7
					}]:[])
					.concat([{
                        name: '拼团',
                        value: 8
                    }])
				);
			},
			
            defaultSearch() {
                let param = {
                    check_state: this.check_state ? this.check_state.split(',') : [],
                    order_state: this.order_state ? this.order_state.split(',') : [],
                    invoice_state: this.invoice_state ? this.invoice_state.split(',') : [],
                    reconciliation_state: this.reconciliation_state? this.reconciliation_state.split(',') : [],
                }

                if (this.pay_state == 1) {
                    param.pay_start_date = new Date().format('yyyy-MM-dd') + ' 00:00:00';
                    param.pay_end_date = new Date().format('yyyy-MM-dd') + ' 23:59:59';
                }

                return param;
            }
        },

        watch: {
            defaultSearch(val) {
                this.$refs.searchForm.set(val);
                this.$nextTick(() => {
                    this.$refs.search.search();
                })
            }
        },

        mounted() {
            this.$refs.searchForm.set(this.defaultSearch);
            this.$nextTick(() => {
                this.$refs.search.search();
            })
            this.$bus.$on('order.update', data => {
                // 刷新列表
                this.$refs.table.update();
            });
        },


		methods: {
			//搜索
			searchHandle(data) {
				data.stationed_type = 1;
				this.searchDate = data;
				this.$refs.table.load({
					url: '/order/list',
					data
				});
                this.searchParams = data||{};
			},
			//关闭订单（弹框）
			closeHandle(stop,data){
				if (!stop) {
					this._order_number = data.order_number;
					this.cancel_reason = '';
					this.$refs.closeDia.open();
				} else {
					stop();
					if (!this.cancel_reason.trim()) {
						this.$message({
							text: '请填写关闭订单原因'
						});
						return;
					}
					this.closeSubmitForm();
					this.$refs.closeDia.close();
					this.$bus.$emit('order.update', {});
				
				}
			},
			//关闭订单（提交数据）
			closeSubmitForm() {
				this.request({
					url: '/order/cancel',
					data: {
						order_number: this._order_number,
						cancel_reason: this.cancel_reason.trim()
					},
					loading: true,
					success: () => {
						this.$message({
							icon: 'success',  
							text: '申请取消订单成功'
						});
						this.$refs.table.update();
					}
				});
			},
			//修改收货地址（弹框）
            editReceivingAddress(val){
                this.$refs.receivingForm.clear();
                this.$refs.receivingForm.set(val);
                this.$refs.receivingDia.open();
            },
			//修改收货地址（提交数据）
            receivingSubmitForm(stop){
                stop();
                this.$refs.receivingForm.submit({
                    url: '/order/edit_receiving_address',
                    rule: {
                        receiving_name: '请填写收货人',
                        receiving_phone: '请填写电话',
                        receiving_address: '请填写收货地址',
                    },
                    dataFormatter: data => {
                        return data;
                    },
                    success: (data, res) => {
                        this.$message({
                            text: '修改收货信息成功！'
                        });
                        this.$refs.table.update();
                        this.$refs.receivingDia.close();
                    }
                });
            },
			//订单下载
			downOrder(d,type){
				this.request({
				    url: '/order/getdownloadurl',
				    data: {
				        order_number: d.order_number,
						type: type
				    },
				    loading: true,
				    success: data => {
				        window.open(data);
				    }
				});
			},
			//批量导出订单
			exportData() {
				var data = this.searchDate;
				data.job_id = 34;
				data.order_numbers = Array.from(this.$refs.table.getRow('selected'), item => item.data.order_number);
				this.request({
					url: '/export_job/add',
					data: data,
					loading: true,
					success: data => {
						this.$message({
							text: '订单导出任务提交成功，请稍后前往任务中心查看'
						});
					}
				});
				
			},
			//单个开票完成
			onInvoiceFinish(data) {
				var text_msg = `确定要对订单【<font style="font-size:15px;color:red;">${data.order_number}</font>】执行开票完成操作吗？`;
				this.realityMoney = (parseFloat(data.payment_money) || 0).toFixed(2);
				this.is_bath = 0;
				this.openInvoiceFinish(text_msg,[data.id]);
			},
			//批量开票完成
			batchInvoiceFinish() {
				this.is_bath = 1;
				this.realityMoney = null;
				var selectDatas = this.$refs.table.getRow('selected');
				var is_flag = true;
				if (!selectDatas.length) {
					stop();
					this.$message({
						text: '请选择需要执行开票完成的订单'
					});
					return;
				}
				
				selectDatas.forEach(item => {
					if(item.data.order_state !=5 || item.data.invoice_count <= 0 || item.data.invoice_state == 2 || item.data.check_state == 1){
						is_flag = false;
					}
				});
				
				if(!is_flag){
					this.$message({
						icon: 'fail',  // 图标（success：成功，fail：失败）
						text: '选择的订单中存在不符合开票条件的订单！'
					});
					return;
				}
				var order_ids = Array.from(selectDatas, item => item.data.id);
				var text_msg = `确定要对已选的【<font style="font-size:15px;color:red;">${selectDatas.length}笔</font>】订单执行开票完成操作吗？`;
				this.openInvoiceFinish(text_msg,order_ids);
				
			},
			//开票完成弹框
			openInvoiceFinish(text_msg,order_ids){
				this.text_msg = text_msg;
				this.order_ids = order_ids;
				this.invoiceDate = new Date().format('yyyy-MM-dd hh:mm:ss');
				this.invoice_file_type = 1;
				this.invoice_file = '';
				this.$refs.invoiceConf.open();
			},
			//提交开票完成信息
			submitInvoiceFinish(stop){
				stop();
				if (!this.invoiceDate) {
					this.$message({
						text: '请选择开票时间'
					});
					return;
				}
				if(this.is_bath == 0){
					if (!this.realityMoney) {
						this.$message({
							text: '请输入实收金额'
						});
						return;
					}
                    if (!this.invoice_file_type) {
                        this.$message({
                            text: '请选择开票凭证'
                        });
                        return;
                    }
                    if (!this.invoice_file) {
                        if(this.invoice_file_type == 1){
                            this.$message({
                                text: '请上传附件'
                            });
                            return;
                        }
                        if(this.invoice_file_type == 2){
                            this.$message({
                                text: '请输入链接'
                            });
                            return;
                        }
                    } else if (this.invoice_file_type == 2 ) {
                        if(this.invoice_file.indexOf('http://') !== 0 && this.invoice_file.indexOf('https://') !== 0){
                            this.$message({
                                text: '请输入以http://或https://开头的完整链接'
                            });
                            return;
                        }
					}
				}
				this.request({
					url: '/order/invoice_finish',
					data: {
						order_ids: this.order_ids,
						invoice_date: this.invoiceDate,
						reality_money: this.realityMoney,
						is_bath: this.is_bath,
                        invoice_file_type: this.invoice_file_type,
                        invoice_file: this.invoice_file
					},
					loading: true,
					success: data => {
						this.$message({
							icon: 'success',  
							text: '执行开票完成操作成功'
						});
						this.$refs.table.update();
						this.$refs.invoiceConf.close();
						this.$refs.invoiceConfForm.clear();
					}
				});
			},
            //选择商家响应事件方法
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			},
            //修改买家留言
            reMarkHandle(data) {
                this.orderNumber = data.order_number;
                this.orderRemark = data.order_remark||'';
                this.$refs.orderRemark.open();
            },
            //修改买家留言确认框响应方法
            orderRemarkHandle(stop) {
                stop();
                if (!this.orderRemark || this.orderRemark.trim().length==0) {
                    this.$message({
                        text: '请填写买家留言'
                    });
                    return;
                }

                this.request({
                    url: '/order/update_remark',
                    data: {
                        order_number: this.orderNumber,
                        order_remark: this.orderRemark.trim()
                    },
                    loading: true,
                    success: () => {
                        this.$refs.orderRemark.close();
                        this.$message({
                            text: '修改买家留言成功'
                        });
                        // 刷新列表
                        this.$refs.table.update();
                    }
                });
            },
            /**
             * 订单转采购单
             * */
            transferPurchaseh(data){
                this.$refs.orderTransferPurchase.open({
                    order_number:data.order_number
                });
            },
            /**
             * 同步导出数据
             * @param work_type
             */
            syncExport(){
                var selectDatas = this.$refs.table.getRow('selected');
                var order_ids = [];
                if (selectDatas.length && selectDatas.length>0) {
                    order_ids = Array.from(selectDatas, item => item.data.id);
                }
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        ids:order_ids,
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>
<style lang="stylus" scoped>	
	.order {
		&-verify {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 120px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
		
		&-remark {
			padding: 20px;
			
			textarea {
				box-sizing: border-box;
				width: 100%;
				height: 200px;
				border: none;
				padding: 10px 14px;
				line-height: 20px;
				background: #FAFAFA;
				resize: none;
			}
		}
	}
	
	.invoice {
		padding: 5px 10px;
		box-sizing: border-box;
		
		p {
			font-weight: bold;
			margin-bottom: 30px;
			font-size: 15px;
		}
	}
</style>